export const a11yPreferences = {
  get reducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  },
}

export default a11yPreferences
